<dx-popup [width]="1200"
          [height]="740"
          [showTitle]="false"
          [title]="title"
          [dragEnabled]="false"
          [closeOnOutsideClick]="false"
          [(visible)]="popupVisible">
    <div *dxTemplate="let data of 'content'">
        <h5 class="ap-green">Choose Site</h5>
        <h7 style="color: red;">Choose a site based on name, country, state and/or city then click Select, Close button</h7>
        <div id="form-container">
            <dx-form id="form" [colCount]="10" [formData]="frmCustomerSite" [showColonAfterLabel]="true">
                <dxi-item [colSpan]="4">
                    <dxo-label text="Site Name"></dxo-label>
                    <dx-text-box [(value)]="siteName" [showClearButton]="true" valueChangeEvent="keyup" (onValueChanged)="siteValueChanged($event)"></dx-text-box>
                </dxi-item>
                <dxi-item [colSpan]="2">
                    <dxo-label text="Country"></dxo-label>
                    <dx-select-box [dataSource]="filteredCountries" placeholder="Choose Country" [showClearButton]="true" [searchEnabled]="true"
                                   (onValueChanged)="onCountryValueChanged($event)" [(value)]="country"></dx-select-box>
                </dxi-item>
                <dxi-item [colSpan]="2">
                    <dxo-label text="State"></dxo-label>
                    <dx-select-box [dataSource]="filteredStates" placeholder="Choose State" [showClearButton]="true" [searchEnabled]="true"
                                   (onValueChanged)="onStateValueChanged($event)" [(value)]="state"></dx-select-box>
                </dxi-item>
                <dxi-item [colSpan]="2">
                    <dxo-label text="City"></dxo-label>
                    <dx-select-box [dataSource]="citiesDataSource" placeholder="Choose City" [showClearButton]="true" [(value)]="city"
                                   [searchEnabled]="true" (onValueChanged)="onCityValueChanged($event)">
                    </dx-select-box>
                </dxi-item>
            </dx-form>
        </div>

        <dx-list #list [(dataSource)]="filteredCustomerSiteList" [height]="400" selectionMode="single" [selectedItemKeys]="[]">

            <div *dxTemplate="let data of 'item'">
                <div>{{ data.customer }}</div>
            </div>
        </dx-list>
        <div>
            <dx-button text="Select Close" stylingMode="contained" type="default" (onClick)="selectSite()" *ngIf="filteredCustomerSiteList && filteredCustomerSiteList.length >
                0 && list && list.selectedItems && list.selectedItems.length > 0">
            </dx-button>&nbsp;
            <dx-button text="Cancel" stylingMode="containded" type="danger" (onClick)="closePopup()"></dx-button>&nbsp;
            <dx-button text="Add new customer site" stylingMode="contained" type="default" (onClick)="addNewCustomerSite()"></dx-button>
        </div>
    </div>
</dx-popup>

<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
               [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>